// English transactional e-mails (same shape as email.nl.ts; the type keeps them in sync).
export const emailEn = {
    buttonFallback: 'Button not working? Copy this link: {url}',
    verify: {
        subject: 'Confirm your e-mail address for {product}',
        lines: [
            'Welcome! Confirm your e-mail address so you can use your family board.',
            'This link is valid for 24 hours. Did not create an account? Then ignore this e-mail.',
        ],
        cta: 'Confirm e-mail address',
    },
    reset: {
        subject: 'Reset your password',
        lines: [
            'You asked for a new password.',
            'This link is valid for 60 minutes and works once. Did not ask for this? Then ignore this e-mail; your password stays the same.',
        ],
        cta: 'Choose a new password',
    },
    invitation: {
        subject: 'Invitation to the family board of {household}',
        lines: [
            'You have been invited to join the family board of {household}.',
            'The invitation is valid for 7 days.',
        ],
        cta: 'Accept invitation',
    },
    // Golf 8 (0050): uitnodiging voor de familiekring. Geen woorden over gezondheid; wel dat het
    // geen alarmdienst is.
    // Golf 8 ronde 1 (ON-3): een huisgenoot uitnodigen (rol parent).
    houseInvite: {
        subject: '{inviter} invites you to {household}',
        lines: [
            '{inviter} invites you to {household} on AMUMIN: the rota, who is in for dinner, bookings and shared costs, on your own phone.',
            'Housemates get the same rights as {inviter}.',
            'The invitation is valid for 7 days.',
        ],
        cta: 'View invitation',
    },
    circleInvite: {
        subject: '{inviter} invites you to follow along',
        lines: [
            '{inviter} invites you to follow along with the family board of {household}, as "{label}".',
            '{name} says on the board whether that is fine. After that you only see what {name} approves.',
            'This is not an alarm service.',
            'The invitation is valid for 7 days.',
        ],
        cta: 'View invitation',
    },
    existingAccount: {
        subject: 'You already have a {product} account',
        lines: [
            'Someone tried to create a new account with this e-mail address, but one already exists.',
            'Was this you? Then just log in. Forgot your password? Ask for a new one with the button below.',
            'Was this not you? Then you do not need to do anything; nothing has changed.',
        ],
        cta: 'Log in',
    },
    newLogin: {
        subject: 'New login to your {product} account',
        lines: [
            'On {when} someone logged in from a browser we did not know yet.',
            'Was this you? Then you do not need to do anything.',
            'Was this not you? Change your password and log out everywhere via {origin}/instellingen/beveiliging.',
        ],
    },
    devicePaired: {
        subject: 'Tablet "{device}" paired with {room}',
        lines: [
            'On {when} the tablet "{device}" was paired with the room {room} of your family board.',
            'Did you or your partner do this? Then you do not need to do anything.',
            'Do you not recognise this? Revoke the pairing via {origin}/apparaten and change your password.',
        ],
    },
    loginCode: {
        subject: '{code} is your code for {product}',
        code: 'Your code: {code}',
        whyNetwork: 'You want to add a network as trusted. Enter this code to confirm.',
        whyLogin: 'Someone logged in with your password. Enter this code in the same browser; after confirming we trust that browser for 30 days (until {until}).',
        details: 'Browser: {browser} · network: {network} · {when}.',
        unknown: 'unknown',
        validity: 'The code is valid for 10 minutes.',
        warning: 'We never ask for this code by phone, chat or e-mail; only enter it on {host}.',
        cta: 'This was not me',
    },
    trustedBrowser: {
        subject: 'New trusted browser for {product}',
        someBrowser: 'A browser',
        lines: [
            '{browser} is now a trusted browser, valid until {until}.',
            'Until then we will not ask for an e-mail code in that browser; your password is always needed.',
            'Was this not you? Change your password and forget all browsers via {origin}/instellingen/beveiliging.',
        ],
    },
    trustedNetwork: {
        subject: '{label} {verb} by {name}',
        verbs: {
            added: 'added as a trusted network (not confirmed yet)',
            confirmed: 'confirmed as a trusted network',
            updated: 'changed',
            disabled: 'switched off as a trusted network',
            removed: 'removed as a trusted network',
        },
        household: 'This applies to all parents in the household: from this network we do not ask for an e-mail code after the password.',
        identity: 'This only applies to {name}.',
        check: 'Is this not right? Check the trusted networks via {origin}/instellingen/beveiliging.',
    },
    lockout: {
        subject: 'Logging in with an e-mail code is blocked for now',
        lines: [
            'Too many login codes were requested or entered wrongly. Until {until} we will not send new codes.',
            'Was this not you? Then someone else may know your password: change it via "Forgot password".',
        ],
    },
    wanChanged: {
        subject: 'The internet address of your server has changed',
        lines: [
            'On {when} the server got a new internet address from your provider.',
            'The trusted network "Home (WAN)" follows this automatically. Did you not expect this? Check your router and the trusted networks.',
        ],
    },
    recoveryReuse: {
        subject: 'Note: tablet "{device}" marked as suspicious',
        lines: [
            'The recovery token of the tablet "{device}" was used a second time.',
            'The tablet is marked as suspicious for now. Check in the app under Tablets whether everything is right, then confirm or revoke the pairing.',
        ],
    },
    familyLink: {
        subject: '{name} wants to link your family boards',
        lines: [
            '{name} wants to share a few things with you, such as birthdays and wish lists.',
            'You then choose yourselves what you share back. The invitation is valid for 7 days.',
            'No {product} yet? Then first create a free account with this e-mail address.',
        ],
        cta: 'View link',
    },
    billing: {
        signupCode: {
            subject: '{code} is your code to finish signing up',
            lines: [
                'Welcome to {product}! Your code is {code}.',
                'Type the code on the screen where you are signing up, or use the button below in the same browser.',
                'The code is valid for 10 minutes and the button for 24 hours. Did not sign up? Then ignore this e-mail; nothing will happen.',
                'We never ask for this code by phone, chat or e-mail; only enter it on {host}.',
            ],
            cta: 'Finish signing up',
        },
        priceLine: 'After that it costs {price}. You can cancel at any time.',
        priceUnknown: 'We will tell you well before the end what it costs after that. You can cancel at any time.',
        perMonth: '{amount} per month',
        trialWelcome: {
            subject: 'Welcome! Your trial month runs until {date}',
            lines: [
                'Great that you are using {product}. The first month is free, up to and including {date}.',
                'You do not need to pay or fill in anything now. A week before the end we will send a reminder.',
            ],
            cta: 'Open the app',
        },
        trialReminder7d: {
            subject: 'One more free week: your trial runs until {date}',
            lines: [
                'Your trial month of {product} runs until {date}.',
                'Want to continue afterwards? Add your payment details in Settings › Subscription.',
                'If you do nothing, you can still view everything afterwards, but no longer add or change things. We delete nothing.',
            ],
            cta: 'View subscription',
        },
        trialReminder1d: {
            subject: 'Today is your last free day',
            lines: [
                'Today ({date}) is the last day of your free month of {product}.',
                'Want to continue without a break? Add your payment details today in Settings › Subscription.',
                'If you do nothing, the board switches to view-only tomorrow. Your data stays safe.',
            ],
            cta: 'Add payment details',
        },
        trialExpired: {
            subject: 'Your trial month has ended',
            lines: [
                'Your free month of {product} has ended. Everything is still there: you can view the calendar and the rest, also on the board.',
                'Adding and changing things works again as soon as you add your payment details.',
                'Want to stop? Then you do not need to do anything. We never delete your data on our own; you can delete it in Settings › Your data.',
            ],
            cta: 'View subscription',
        },
        expiredFollowup: {
            subject: 'Would you like to continue with {product}?',
            lines: [
                'Your trial month ended a month ago. The board is still view-only.',
                'You can continue at any time: add your payment details in Settings › Subscription.',
                'Rather stop? Then cancel or delete the family board in Settings › Your data. We will not e-mail you about this again.',
            ],
            cta: 'View subscription',
        },
        cancelled: {
            subject: 'Your subscription has been cancelled',
            lines: [
                'You cancelled your subscription to {product}. Until {date} everything works as it does now.',
                'After that you can still view everything, but no longer change anything. We delete nothing on our own.',
                'Changed your mind? You can continue until {date} in Settings › Subscription.',
            ],
            cta: 'View subscription',
        },
    },
};
//# sourceMappingURL=email.en.js.map